import React from 'react'
import about from './about.module.css'
import aboutus from '../../../Assets/About/aboutImg.png'
import { NavLink } from 'react-router-dom'
import defaultIMG from "../../../Assets/defaultimg.png";
const About1 = () => {
    return (
        <div className={about.about1_container}>
            <div className={about.about1div1_container}>
                <h1 className={about.abouth1text}>Company About</h1>
                <p className={about.text_container}>

                    <ul>
                        <li><NavLink to='/' className={({ isActive }) => isActive && about.active}>Home</NavLink></li>
                        <span>|</span>
                        <li><NavLink to='/about' className={({ isActive }) => isActive && about.active}>Company About</NavLink></li>
                    </ul>
                </p>
            </div>
            <div className={about.about1image_container}>
                <img src={aboutus} alt='image'
                   onError={({ currentTarget }) => {
                    currentTarget.onerror = null; 
                    currentTarget.src= defaultIMG ;
                  }}
                 className={about.aboutImg} />
            </div>

        </div>
    )
}

export default About1